/* Dreamora theme scripts — no dependencies */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const markReady = el => { if (el.dataset.ready) return true; el.dataset.ready = '1'; return false; };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    list(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, dec, thou, decSep) => {
      const fixed = (n / 100).toFixed(dec).split('.');
      return fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (fixed[1] ? decSep + fixed[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  const priceHtml = (price, compare) =>
    `<span class="price${compare > price ? ' price--sale' : ''}"><span class="price__now">${formatMoney(price)}</span>${compare > price ? ` <s class="price__was">${formatMoney(compare)}</s>` : ''}</span>`;
  const sizedImage = (src, w) => { try { const u = new URL(src, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; } };
  const escapeHtml = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header || markReady(header)) return;
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
      const btn = $('[data-to-top]');
      if (btn) btn.classList.toggle('is-visible', window.scrollY > 600);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers & modals ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = $('input, button, a', $('.drawer__panel, .modal__panel, .search-modal__panel', d) || d);
    focusable && setTimeout(() => focusable.focus(), 60);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open, .search-modal.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function initDrawers() {
    document.addEventListener('click', e => {
      const opener = e.target.closest('[data-open]');
      if (opener) {
        const id = opener.dataset.open;
        if (id === 'CartDrawer' && (!document.getElementById('CartDrawer') || window.theme.cartDrawer === false)) return;
        e.preventDefault();
        openDrawer(id);
        return;
      }
      const closer = e.target.closest('[data-close]');
      if (closer) { const d = closer.closest('.drawer, .search-modal, .modal'); d && closeDrawer(d); return; }
      if (e.target.classList.contains('search-modal') || e.target.classList.contains('modal')) closeDrawer(e.target);
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      $$('.drawer.is-open, .search-modal.is-open, .modal.is-open').forEach(closeDrawer);
    });
    const top = $('[data-to-top]');
    top && top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }));
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const input = $('[data-predictive-input]');
    const results = $('[data-predictive-results]');
    const suggest = $('[data-predictive-suggest]');
    if (!input || !results || !window.theme.predictiveSearch) return;
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; suggest && (suggest.hidden = false); return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${window.theme.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const r = data.resources.results;
          const products = r.products || [];
          const colls = r.collections || [];
          suggest && (suggest.hidden = true);
          if (!products.length && !colls.length) {
            results.innerHTML = `<p class="search-modal__empty">No matches for “${escapeHtml(q)}”. Try another word?</p>`;
            return;
          }
          results.innerHTML =
            (colls.length ? `<div class="pills">${colls.map(c => `<a class="pill" href="${c.url}">${escapeHtml(c.title)}</a>`).join('')}</div>` : '') +
            `<div class="search-modal__grid">${products.map(p => `
              <a href="${p.url}" class="search-hit">
                <span class="search-hit__img">${p.image ? `<img src="${sizedImage(p.image, 200)}" alt="" loading="lazy">` : ''}</span>
                <span><span class="search-hit__title">${escapeHtml(p.title)}</span>${priceHtml(Math.round(parseFloat(p.price) * 100), Math.round(parseFloat(p.compare_at_price_max || 0) * 100))}</span>
              </a>`).join('')}</div>
            <a class="btn btn--outline btn--block" href="${window.theme.routes.search_url}?q=${encodeURIComponent(q)}&type=product">See all results</a>`;
        } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach(tabs => {
      if (markReady(tabs)) return;
      const btns = $$('[data-tab]', tabs);
      btns.forEach(btn => btn.addEventListener('click', () => {
        btns.forEach(b => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', String(b === btn)); });
        $$('[data-tab-panel]', tabs).forEach(p => { p.hidden = p.dataset.tabPanel !== btn.dataset.tab; });
      }));
    });
  }

  /* ---------- Reveal ---------- */
  function initReveal(root = document) {
    const els = $$('[data-reveal]', root);
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(e => e.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach(e => io.observe(e));
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root = document) {
    $$('[data-hero]', root).forEach(hero => {
      if (markReady(hero)) return;
      const slides = $$('.hero__slide', hero);
      const dots = $$('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      let i = 0, timer;
      const go = n => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, j) => { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', String(j !== i)); });
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      };
      const play = () => {
        clearInterval(timer);
        if (hero.dataset.autoplay === 'true' && !reduceMotion) timer = setInterval(() => go(i + 1), Number(hero.dataset.speed || 6) * 1000);
      };
      $('[data-hero-prev]', hero).addEventListener('click', () => { go(i - 1); play(); });
      $('[data-hero-next]', hero).addEventListener('click', () => { go(i + 1); play(); });
      dots.forEach(d => d.addEventListener('click', () => { go(Number(d.dataset.heroDot)); play(); }));
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', () => clearInterval(timer));
      let sx = null;
      hero.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', e => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
        sx = null;
      });
      hero._go = go;
      play();
    });
  }

  /* ---------- Sliders (scroll-snap) ---------- */
  function initSliders(root = document) {
    $$('[data-slider]', root).forEach(slider => {
      if (markReady(slider)) return;
      const track = $('[data-slider-track]', slider);
      if (!track) return;
      const bar = $('[data-slider-bar]', slider);
      const dotsWrap = $('[data-slider-dots]', slider);
      const step = () => {
        const slide = track.firstElementChild;
        return slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      };
      const pages = () => Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
      const buildDots = () => {
        if (!dotsWrap) return;
        const n = pages();
        dotsWrap.innerHTML = n > 1 ? Array.from({ length: n }, (_, k) => `<button type="button" class="dot" aria-label="Go to page ${k + 1}" data-page="${k}"></button>`).join('') : '';
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const p = max > 0 ? track.scrollLeft / max : 1;
        if (bar) {
          bar.style.width = `${Math.max(track.clientWidth / track.scrollWidth, 0.12) * 100}%`;
          bar.style.left = `${p * (100 - parseFloat(bar.style.width))}%`;
        }
        const prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
        prev && (prev.disabled = track.scrollLeft <= 2);
        next && (next.disabled = track.scrollLeft >= max - 2);
        if (dotsWrap) {
          const active = Math.round(p * (pages() - 1));
          $$('.dot', dotsWrap).forEach((d, k) => d.classList.toggle('is-active', k === active));
        }
        slider.classList.toggle('is-static', max <= 2);
      };
      const prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      dotsWrap && dotsWrap.addEventListener('click', e => {
        const d = e.target.closest('[data-page]');
        if (d) track.scrollTo({ left: Number(d.dataset.page) * track.clientWidth, behavior: 'smooth' });
      });
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', () => { buildDots(); update(); });
      buildDots();
      update();
    });
  }

  /* ---------- Coverflow ---------- */
  function initCoverflow(root = document) {
    $$('[data-coverflow]', root).forEach(cf => {
      if (markReady(cf)) return;
      const cards = $$('.coverflow__card', cf);
      if (!cards.length) return;
      let active = Math.floor(cards.length / 2);
      const layout = () => {
        const w = cards[0].offsetWidth;
        const n = cards.length;
        cards.forEach((c, i) => {
          let off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          const abs = Math.abs(off);
          const x = off * w * 0.78;
          const scale = 1 - Math.min(abs, 3) * 0.12;
          const rot = off * -4;
          c.style.transform = `translate(-50%, -50%) translateX(${x}px) scale(${scale}) rotate(${rot}deg)`;
          c.style.zIndex = String(10 - abs);
          c.style.opacity = abs > 2 ? '0' : '1';
          c.style.pointerEvents = abs > 2 ? 'none' : '';
          c.classList.toggle('is-active', off === 0);
          c.tabIndex = off === 0 ? 0 : -1;
        });
      };
      const go = n => { active = (n + cards.length) % cards.length; layout(); };
      cards.forEach((c, i) => c.addEventListener('click', e => { if (i !== active) { e.preventDefault(); go(i); } }));
      const section = cf.closest('section') || document;
      const prev = $('[data-cf-prev]', section), next = $('[data-cf-next]', section);
      prev && prev.addEventListener('click', () => go(active - 1));
      next && next.addEventListener('click', () => go(active + 1));
      let sx = null;
      cf.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      cf.addEventListener('touchend', e => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1));
        sx = null;
      });
      window.addEventListener('resize', layout);
      layout();
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach(el => {
      if (markReady(el)) return;
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.max(0, end - Date.now());
        const s = Math.floor(left / 1000);
        $('[data-cd="d"]', el).textContent = pad(Math.floor(s / 86400));
        $('[data-cd="h"]', el).textContent = pad(Math.floor(s / 3600) % 24);
        $('[data-cd="m"]', el).textContent = pad(Math.floor(s / 60) % 60);
        $('[data-cd="s"]', el).textContent = pad(s % 60);
        if (left <= 0) { clearInterval(t); el.hidden = true; }
      };
      const t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Cart ---------- */
  const Cart = {
    async post(url, body) {
      const res = await fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong, please try again');
      return data;
    },
    add(items) { return this.post(window.theme.routes.cart_add_url, { items }); },
    change(line, quantity) { return this.post(window.theme.routes.cart_change_url, { line, quantity }); },
    async refresh(sectionsHtml) {
      if (!sectionsHtml) {
        const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
        sectionsHtml = await res.json();
      }
      const html = sectionsHtml['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('CartDrawer');
      const cur = document.getElementById('CartDrawer');
      if (fresh && cur) {
        $('.drawer__panel', cur).innerHTML = $('.drawer__panel', fresh).innerHTML;
        const count = fresh.dataset.count;
        $$('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count === '0'; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
      }
    },
    async afterAdd(data) {
      await this.refresh(data && data.sections);
      if (document.getElementById('CartDrawer') && window.theme.cartDrawer !== false) openDrawer('CartDrawer');
      else toast('Added to your bag');
    }
  };
  window.DreamoraCart = Cart;

  function initCartForms() {
    document.addEventListener('submit', async e => {
      const form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      btn && btn.classList.add('is-loading');
      try {
        const fd = new FormData(form);
        const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
        const props = {};
        for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
        if (Object.keys(props).length) item.properties = props;
        await Cart.afterAdd(await Cart.add([item]));
      } catch (err) {
        toast(err.message);
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    });

    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-cart-line]');
      if (!b) return;
      e.preventDefault();
      const wrap = b.closest('.drawer__panel, .cart-page');
      wrap && wrap.classList.add('is-loading');
      try {
        const data = await Cart.change(Number(b.dataset.cartLine), Number(b.dataset.qty));
        if (b.closest('.cart-page')) { window.location.reload(); return; }
        await Cart.refresh(data.sections);
      } catch (err) { toast(err.message); }
      finally { wrap && wrap.classList.remove('is-loading'); }
    });
  }

  /* ---------- Product cards: swatches ---------- */
  function initCardSwatches() {
    document.addEventListener('click', e => {
      const sw = e.target.closest('.card .swatch');
      if (!sw) return;
      e.preventDefault();
      const card = sw.closest('.card');
      $$('.swatch', card).forEach(s => s.classList.toggle('is-active', s === sw));
      const input = $('form input[name="id"]', card);
      if (input && sw.dataset.variantId) input.value = sw.dataset.variantId;
      const addBtn = $('.card__quick button[type="submit"]', card);
      if (addBtn) addBtn.disabled = sw.dataset.available === 'false';
      if (sw.dataset.image) {
        const img = $('.card__img--primary', card);
        if (img) { img.srcset = ''; img.src = sw.dataset.image; }
      }
      if (sw.dataset.price) {
        const price = $('[data-card-price]', card);
        if (price) price.innerHTML = sw.dataset.price;
      }
    });
  }

  /* ---------- Wishlist ---------- */
  const WISH_KEY = 'dreamora-wishlist';
  const Wishlist = {
    all() { return store.list(WISH_KEY); },
    has(h) { return this.all().includes(h); },
    toggle(h) {
      const list = this.all();
      const i = list.indexOf(h);
      if (i === -1) list.unshift(h); else list.splice(i, 1);
      store.set(WISH_KEY, JSON.stringify(list.slice(0, 60)));
      return i === -1;
    },
    paint() {
      const list = this.all();
      $$('[data-wishlist-toggle]').forEach(b => {
        const on = list.includes(b.dataset.handle);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      $$('[data-wishlist-count]').forEach(c => { c.textContent = list.length; c.hidden = list.length === 0; });
    }
  };

  async function renderHandles(handles, grid) {
    const html = await Promise.all(handles.map(h =>
      fetch(`${window.theme.routes.root_url.replace(/\/$/, '')}/products/${encodeURIComponent(h)}?view=card`)
        .then(r => (r.ok ? r.text() : ''))
        .catch(() => '')
    ));
    grid.innerHTML = html.join('');
    Wishlist.paint();
    return html.filter(Boolean).length;
  }

  function initWishlist() {
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-wishlist-toggle]');
      if (!b) return;
      e.preventDefault();
      const added = Wishlist.toggle(b.dataset.handle);
      Wishlist.paint();
      toast(added ? 'Saved to your wishlist' : 'Removed from your wishlist');
      const page = $('[data-wishlist-page]');
      if (page && !added) { const card = b.closest('.card'); card && card.remove(); if (!$('.card', page)) $('[data-wishlist-empty]', page).hidden = false; }
    });
    Wishlist.paint();

    const page = $('[data-wishlist-page]');
    if (page) {
      const list = Wishlist.all();
      const grid = $('[data-wishlist-grid]', page);
      if (!list.length) { $('[data-wishlist-empty]', page).hidden = false; return; }
      renderHandles(list, grid).then(n => { if (!n) $('[data-wishlist-empty]', page).hidden = false; });
    }
  }

  /* ---------- Recently viewed ---------- */
  const RECENT_KEY = 'dreamora-recent';
  function initRecent() {
    const product = $('[data-product][data-handle]');
    const current = product && product.dataset.handle;
    const section = $('[data-recently]');
    if (section) {
      const limit = Number(section.dataset.limit || 4);
      const list = store.list(RECENT_KEY).filter(h => h !== current).slice(0, limit);
      if (list.length) {
        renderHandles(list, $('[data-recently-grid]', section)).then(n => { section.hidden = n === 0; });
      }
    }
    if (current) {
      const list = store.list(RECENT_KEY).filter(h => h !== current);
      list.unshift(current);
      store.set(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    }
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-product]').forEach(root => {
      const json = $('script[data-product-json]', root);
      if (!json) return;
      const product = JSON.parse(json.textContent);
      const form = $('form[data-product-form]', root);
      if (!form) return;
      const idInput = $('input[name="id"]', form);
      const btn = $('[data-add-btn]', root);
      const priceEl = $('[data-price]', root);
      const badge = $('[data-sale-badge]', root);
      const stock = $('[data-stock]', root);
      const low = Number(root.dataset.lowStock || 0);
      const sticky = $('[data-sticky-atc]');

      const showMedia = id => {
        const slide = $(`.product__slide[data-media-id="${id}"]`, root);
        if (!slide) return;
        $$('.product__slide', root).forEach(s => s.classList.toggle('is-active', s === slide));
        $$('.product__thumb', root).forEach(t => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
        const main = $('[data-gallery-main]', root);
        if (main && window.innerWidth < 990) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      };
      $$('.product__thumb', root).forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
      const main = $('[data-gallery-main]', root);
      main && main.addEventListener('scroll', () => {
        if (window.innerWidth >= 990) return;
        const idx = Math.round(main.scrollLeft / main.clientWidth);
        const slide = $$('.product__slide', root)[idx];
        slide && $$('.product__thumb', root).forEach(t => t.classList.toggle('is-active', t.dataset.thumb === slide.dataset.mediaId));
      }, { passive: true });

      const update = () => {
        const selected = $$('fieldset[data-option-index]', root).map(fs => {
          const c = $('input:checked', fs);
          const lbl = $('legend span', fs);
          if (lbl && c) lbl.textContent = c.value;
          return c ? c.value : null;
        });
        const v = product.variants.find(v => v.options.every((o, i) => o === selected[i]));
        const stickyBtn = sticky && $('[data-sticky-add]', sticky);
        if (!v) {
          btn.disabled = true; btn.textContent = 'Unavailable';
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
          return;
        }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.addText : btn.dataset.soldText;
        priceEl.innerHTML = priceHtml(v.price, v.compare_at_price);
        if (badge) {
          const off = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
          badge.hidden = !off;
          badge.textContent = off ? `-${off}%` : '';
        }
        if (stock) {
          const show = v.inventory !== null && v.inventory > 0 && v.inventory <= low;
          stock.hidden = !show;
          if (show) $('[data-stock-count]', stock).textContent = v.inventory;
        }
        if (sticky) {
          $('[data-sticky-price]', sticky).innerHTML = priceHtml(v.price, v.compare_at_price);
          const sv = $('[data-sticky-variant]', sticky);
          if (sv && product.variants.length > 1) sv.textContent = v.title;
          stickyBtn.disabled = !v.available;
          stickyBtn.textContent = v.available ? btn.dataset.addText : btn.dataset.soldText;
        }
        // Mark option values that have no available variant with the other current choices
        $$('fieldset[data-option-index]', root).forEach(fs => {
          const idx = Number(fs.dataset.optionIndex);
          $$('input', fs).forEach(inp => {
            const ok = product.variants.some(x => x.available && x.options[idx] === inp.value && x.options.every((o, k) => k === idx || o === selected[k]));
            inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
          });
        });
        if (v.featured_media) showMedia(v.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      };
      $$('fieldset[data-option-index] input', root).forEach(i => i.addEventListener('change', update));
      if ($$('fieldset[data-option-index]', root).length) update();

      if (sticky && btn && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
        });
        io.observe(btn);
        $('[data-sticky-add]', sticky).addEventListener('click', () => {
          if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
        });
      }
    });

    document.addEventListener('click', e => {
      const b = e.target.closest('[data-qty-step]');
      if (!b) return;
      const input = $('input', b.closest('.qty'));
      input.value = Math.max(1, Number(input.value) + Number(b.dataset.qtyStep));
    });

    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-share]');
      if (!b) return;
      const data = { title: b.dataset.title, url: b.dataset.url };
      try {
        if (navigator.share) { await navigator.share(data); return; }
        await navigator.clipboard.writeText(data.url);
        const lbl = $('[data-share-label]', b);
        const old = lbl.textContent;
        lbl.textContent = 'Link copied!';
        setTimeout(() => { lbl.textContent = old; }, 2000);
      } catch (err) {}
    });
  }

  /* ---------- Related products (lazy) ---------- */
  function initRecommendations() {
    $$('[data-recs-url]').forEach(el => {
      if (el.children.length || markReady(el)) return;
      fetch(el.dataset.recsUrl).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recs-url]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); Wishlist.paint(); }
      }).catch(() => {});
    });
  }

  /* ---------- Collection ---------- */
  function initCollection() {
    const sort = $('[data-sort]');
    sort && sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    const grid = $('[data-collection-grid]');
    const toggles = $$('[data-cols]');
    if (grid && toggles.length) {
      const apply = n => {
        grid.style.setProperty('--cols', n);
        toggles.forEach(t => t.classList.toggle('is-active', t.dataset.cols === String(n)));
      };
      const saved = store.get('dreamora-cols');
      if (saved) apply(saved);
      toggles.forEach(t => t.addEventListener('click', () => { apply(t.dataset.cols); store.set('dreamora-cols', t.dataset.cols); }));
    }

    const filterForm = $('[data-filter-form]');
    filterForm && filterForm.addEventListener('change', e => {
      if (e.target.type === 'number') return;
      filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
    });

    const more = $('[data-load-more-btn]');
    more && more.addEventListener('click', async e => {
      e.preventDefault();
      more.classList.add('is-loading');
      const pageUrl = more.href;
      try {
        const html = await fetch(pageUrl).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = $$('[data-collection-grid] > .card', doc);
        cards.forEach(c => grid.appendChild(document.importNode(c, true)));
        const nextBtn = $('[data-load-more-btn]', doc);
        const seen = $$('.card', grid).length;
        const total = Number(more.dataset.total || seen);
        $('[data-seen]').textContent = Math.min(seen, total);
        $('[data-seen-bar]').style.width = `${Math.min(100, seen * 100 / total)}%`;
        if (nextBtn) more.href = nextBtn.href; else more.closest('[data-load-more]').querySelector('.btn').remove();
        history.replaceState({}, '', pageUrl);
        Wishlist.paint();
      } catch (err) { window.location.href = pageUrl; }
      finally { more.classList.remove('is-loading'); }
    });
  }

  /* ---------- Newsletter popup ---------- */
  function initPopup() {
    const modal = $('[data-popup]');
    if (!modal) return;
    const key = 'dreamora-popup-dismissed';
    const days = Number(modal.dataset.days || 7);
    const last = Number(store.get(key) || 0);
    const posted = modal.dataset.posted === 'true';
    const dismiss = () => { store.set(key, String(Date.now())); };
    modal.addEventListener('click', e => { if (e.target === modal || e.target.closest('[data-close]')) dismiss(); });
    if (posted) { openDrawer(modal.id); dismiss(); return; }
    if (window.Shopify && Shopify.designMode) return;
    if (Date.now() - last < days * 864e5) return;
    if ($('[data-age-gate]') && !store.get('dreamora-age-ok')) return;
    setTimeout(() => { if (!$('.drawer.is-open, .modal.is-open')) openDrawer(modal.id); }, Number(modal.dataset.delay || 6) * 1000);
  }

  /* ---------- Age check ---------- */
  function initAgeGate() {
    const gate = $('[data-age-gate]');
    if (!gate) return;
    if (store.get('dreamora-age-ok') || (window.Shopify && Shopify.designMode)) return;
    openDrawer(gate.id);
    $('[data-age-yes]', gate).addEventListener('click', () => { store.set('dreamora-age-ok', '1'); closeDrawer(gate); });
    gate.addEventListener('click', e => { if (e.target === gate) e.stopPropagation(); }, true);
  }

  /* ---------- Init ---------- */
  window.Shopify = window.Shopify || {};
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initDrawers();
    initSearch();
    initTabs();
    initReveal();
    initHero();
    initSliders();
    initCoverflow();
    initCountdowns();
    initCartForms();
    initCardSwatches();
    initWishlist();
    initProduct();
    initRecent();
    initRecommendations();
    initCollection();
    initAgeGate();
    initPopup();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', e => {
    initTabs(e.target);
    initReveal(e.target);
    initHero(e.target);
    initSliders(e.target);
    initCoverflow(e.target);
    initCountdowns(e.target);
    initHeader();
    Wishlist.paint();
  });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('.hero__slide');
    const hero = slide && slide.closest('[data-hero]');
    if (hero && hero._go) hero._go($$('.hero__slide', hero).indexOf(slide));
  });
  document.addEventListener('shopify:section:select', e => {
    const m = e.target.querySelector('[data-popup], [data-age-gate]');
    if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); }
  });
  document.addEventListener('shopify:section:deselect', e => {
    const m = e.target.querySelector('[data-popup], [data-age-gate]');
    if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
  });
})();
